import { create } from 'zustand'

import { FilterCategory } from './types'
import { createJSONStorage, persist } from 'zustand/middleware'
import { persistStorage } from '@/shared/state/dataBase/persistStorage'

export interface FilterState {
    filterCategories: FilterCategory[]
    actualCategory: FilterCategory | null

    setFilterCategories: (categories: FilterCategory[]) => void
    setActualCategory: (
        category?: FilterCategory | undefined,
        setAllCategory?: boolean
    ) => void
    clearCategoryAfterRehydrate: () => void
}

export const useFilterStore = create<FilterState>()(
    persist(
        (set) => ({
            filterCategories: [],
            actualCategory: null,

            setActualCategory: (category?: FilterCategory, reset?: boolean) => {
                if (reset) set({ actualCategory: null })
                else set({ actualCategory: category })
            },
            setFilterCategories: (categories: FilterCategory[]) =>
                set({ filterCategories: categories }),
            clearCategoryAfterRehydrate: () => {
                set({ actualCategory: null })
            },
        }),

        {
            name: 'main-storage',
            storage: createJSONStorage(() => persistStorage),
            onRehydrateStorage: (state) => {
                state?.clearCategoryAfterRehydrate()
            },
        }
    )
)
